import instagramLogo from './instagram_logo.svg';
import kickLogo from './kick_logo.svg';
import metaLogo from './meta_logo.svg';
import streamlabsLogo from './streamlabs_logo.svg';
import tiktokLogo from './tiktok_logo.svg';
import twitchLogo from './twitch_logo.svg';
import xLogo from './x_logo.svg';
import youtubeLogo from './youtube_logo.svg';

const logos = {
  youtube: youtubeLogo,
  twitch: twitchLogo,
  tiktok: tiktokLogo,
  streamlabs: streamlabsLogo,
  instagram: instagramLogo,
  x: xLogo,
  kick: kickLogo,
  meta: metaLogo,
};

export default logos;
